import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private appConfig: any;

  constructor(private http: HttpClient) { }

  loadAppConfig() {
    return this.http.get('/assets/data/config.json')
      .toPromise()
      .then(data => {
        this.appConfig = data;
      });
  }

  // This is an example property ... you can make it however you want.
  get apiUrl() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.apiUrl;
  }
  get server() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.server;
  }
  get serverWithApiUrl() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.serverWithApiUrl;
  }

  get CreatedLoginID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.CreatedLoginID;
  }

  get UpdatedLoginID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.UpdatedLoginID;
  }

  get StudentID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.StudentID;
  }

  get StuPoartlaID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.StuPoartlaID;
  }
  get PhysicalDisabilityID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.PhysicalDisabilityID;
  }
  get PhotoPath() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.PhotoPath;
  }

  get SignPath() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.SignPath;
  }

  get Password() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.Password;
  }
  get ApplicationTitle(){
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ApplicationTitle;
  }
  get ApplicationTitleInDevngari(){
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ApplicationTitleInDevngari;
  }
  get IndexTitle(){
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.IndexTitle;
  }

  get portalopen() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.portalopen;
  }
  
  get LogoPath() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.LogoPath;
  }
  
  get ImageSize() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ImageSize;
  }
  
  get SignSize() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.SignSize;
  }
  
  get FileUploadSize() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.FileUploadSize;
  }
  get PaymentAPIURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.PaymentAPIURL;
  }
  get OTPTimeLimt() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.OTPTimeLimt;
  }
  get AcademicInstanceID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.AcademicInstanceID;
  }
  get ExamInstanceID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ExamInstanceID;
  }
  get SysUsrGrpID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.SysUsrGrpID;
  }
  get LoginPageText() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.LoginPageText;
  }
  get PRNNo() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.PRNNo;
  }
  get SmsEmailSendOTPFlag() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.PRNNo;
  }
  get CollegeID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.CollegeID;
  }
  get Collegenm() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.Collegenm;
  }
  get FromProspect() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.FromProspect;
  }
  get progoramlist() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.progoramlist;
  }
  get Logo1() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.Logo1;
  }
  get Logo2() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.Logo2;
  }
  get ProfileLockStatusFlag() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ProfileLockStatusFlag;
  }
  get ProspectFlag() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ProspectFlag;
  }
  get ProspectPurchaseFlag() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ProspectPurchaseFlag;
  }
  get prospectshow() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.prospectshow;
  }
  get loginpageshow() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.loginpageshow;
  }
  get pdflink() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.pdflink;
  }
  get loggedstatus() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.loggedstatus;
  }
  get SupportContact() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.SupportContact;
  }
  get ShowMeritList() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ShowMeritList;
  }
  get marqueeText() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.marqueeText;
  }
  get MeritLinkName() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.MeritLinkName;
  }
  get MeritArray() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.MeritArray;
  }
  get ExternalFlag() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ExternalFlag;
  }
  get IsParrent() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.IsParrent;
  }
  get WeeklyOff() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.WeeklyOff;
  }
  get SubjectShowFlag() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.SubjectShowFlag;
  }
  get ContactDetail() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.ContactDetail;
  }
  get Instructionvideo() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.Instructionvideo;
  }
  get videoshow() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.videoshow;
  }
 /*  get UniversityFlag(){debugger
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.UniversityFlag;
  } */

  get NewRegFlag(){
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.NewRegFlag;
  }

  get OldRegFlag(){
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.OldRegFlag;
  }

}
